import {Button, Dialog, DialogTrigger, Popover} from 'react-aria-components'
import {Range} from 'react-range'

import ChevronDownSvg from '@/assets/icons/chevron-down.svg?react'
import Price from '@/components/Price'
import PrimaryButton from '@/components/PrimaryButton/PrimaryButton'
import {useCurrencySymbol} from '@/lib/locale/country'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

import style from './FilterPrice.module.scss'

interface Props {
  maxPrice: number | null
  setMaxPrice: MemoizedCallbackOrDispatch<number | null>
  maximumPrice: number
  minimumPrice: number
}

export default memo(function FilterPrice(props: Props) {
  const currencySumbol = useCurrencySymbol()

  const valueText = props.maxPrice ? `${currencySumbol}${props.maxPrice}` : 'any'
  const valueTextHelper = props.maxPrice ? 'up to ' : ''
  return (
    <DialogTrigger>
      <Button className={style.Button}>
        <div className={style.Value}>
          <span>
            Price<VisuallyHidden>&nbsp; filter</VisuallyHidden>
            {props.maxPrice ? (
              <>
                :&nbsp;up to&nbsp;
                <Price price={props.maxPrice} />
              </>
            ) : (
              <VisuallyHidden>: any</VisuallyHidden>
            )}
          </span>
        </div>
        <span aria-hidden className={style.Chevron}>
          <ChevronDownSvg
            className={style.ChevronIcon}
            width={12}
            height={16}
            viewBox='0 0 24 24'
            aria-hidden
          />
        </span>
      </Button>
      <Popover className={style.Popover}>
        <Dialog className={style.Dialog}>
          <div className={style.ValueText} aria-hidden>
            Flight price:{' '}
            <span>
              {valueTextHelper}
              {valueText}
            </span>
          </div>
          <Range
            label='Max price'
            step={1}
            min={props.minimumPrice}
            max={props.maximumPrice}
            values={[props.maxPrice ?? props.minimumPrice]}
            onChange={values => {
              if (values[0] === undefined) return
              props.setMaxPrice(values[0])
            }}
            renderTrack={({props, children}) => (
              <div {...props} style={props.style} className={style.Track}>
                {children}
              </div>
            )}
            renderThumb={({props}) => (
              <div {...props} key={props.key} style={props.style} className={style.Thumb} />
            )}
            aria-valuetext={valueText}
          />
          <div className={style.ClearButtonContainer}>
            <PrimaryButton
              size='sm'
              className={style.ClearButton}
              onPress={() => {
                props.setMaxPrice(null)
              }}
            >
              Clear
            </PrimaryButton>
          </div>
        </Dialog>
      </Popover>
    </DialogTrigger>
  )
})
